import React, { useState } from "react";


const Formc = () => {
    const [fullName, setFullName] = useState({
        fname: "",
        lname: "",
    });


    const inputEvent = (event) => {
        console.log(event.target.value);
        console.log(event.target.name);

        const value = event.target.value;
        const name = event.target.name;

        setFullName((preValue => {
            if (name === "fname") {
                return {
                    fname: value,
                    lname: preValue.lname,
                }
            } else if (name === "lname") {
                return {
                    fname: preValue.fname,
                    lname: value,
                }
            }

        }))
    }

    const onSubmit = (event) => {
        event.preventDefault();
        //alert('Submitted');
    }
    return (
        <>
            <div>
                <form onSubmit={onSubmit}>
                    <h1>Hello {fullName.fname} {fullName.lname}</h1>
                    <input type="text" className="form-control" placeholder="Enter your name" name="fname" onChange={inputEvent} value={fullName.fname} />
                    <input type="text" className="form-control" placeholder="Enter your name" name="lname" onChange={inputEvent} value={fullName.lname} />
                    <button type="submit" className="btn btn-primary">Submit</button>
                </form>
            </div>
        </>
    )
}

export default Formc;